import { useApiTableDeletionHelper } from 'components/ApiTable/helpers/useApiTableDeletionHelper';
import { ApiTablePageView } from 'components/ApiTablePage/ApiTablePageView';
import { useApiTablePage } from 'components/ApiTablePage/useApiTablePage';
import type { TableBulkAction } from 'components/Table/model/TableModel';
import { useSimpleConfirmDialog } from 'containers/ConfirmDialog/useSimpleConfirmDialog';
import { memo, useMemo } from 'react';
import type { FC } from 'react';
import { useApi } from 'utils/request/useApi';
import { useTableEndpoint } from 'utils/table/useTableEndpoint';

export const discoveryHistoryApiEndpoint =
  '/tables/inventory/discovery-history';

const BareDiscoveryHistoryPage: FC = () => {
  const confirmDialog = useSimpleConfirmDialog();
  const api = useApi();
  const deletionHelper = useApiTableDeletionHelper({
    confirmDialog,
    getApiTableModel: () => discoveryHistoryApiTablePage.apiTableModel,
    deleteMultiple: (ids: string[]) =>
      api.request({
        url: '/discovery/history',
        method: 'DELETE',
        data: ids,
      }),
  });

  const endpoint = useTableEndpoint({
    apiEndpoint: discoveryHistoryApiEndpoint,
  });

  const bulkActions = useMemo(
    (): TableBulkAction[] => [deletionHelper.deleteBulkAction],
    [deletionHelper],
  );

  const discoveryHistoryApiTablePage = useApiTablePage({
    endpoint,
    additionalApiTableProps: {
      bulkActions,
      rowIdField: 'id',
    },
  });

  return (
    <>
      <ApiTablePageView
        model={discoveryHistoryApiTablePage}
        tableClassName='m'
      />
      {confirmDialog.render()}
    </>
  );
};

export const DiscoveryHistoryPage = memo(BareDiscoveryHistoryPage);
